module.exports = __webpack_public_path__ + "static/img/ic_itembox_epic.12e9bfba.svg";